export default function headerOverlapFooter() {
  const header = document.querySelector('.header')
  const navWrap = document.querySelector('.header')
  const footer = document.querySelector('.footer')

  function checkOverlap() {
      const navWrapRect = navWrap.getBoundingClientRect()
      const footerRect = footer.getBoundingClientRect()

      if (navWrapRect.bottom > footerRect.top) {
          header.classList.add('-is-overlap')
      } else {
          header.classList.remove('-is-overlap')
      }
  }

  window.addEventListener('scroll', checkOverlap)
  window.addEventListener('resize', checkOverlap)
}
